export const ENROLLMENT_PERIODS_QUERY_PREFIX = 'open-enrollment' as const
export const ENROLLMENT_PERIODS_QUERY_KEYS = {
  all: [ENROLLMENT_PERIODS_QUERY_PREFIX, 'oep-enrollment-periods'] as const,
  list: (companyId: string) =>
    [
      ENROLLMENT_PERIODS_QUERY_PREFIX,
      'oep-enrollment-periods',
      companyId,
    ] as const,
} as const
